/**
 * Animation helpers.
 *
 * The mobile app drives these with Animated; on the web the same effects are
 * pure CSS keyframes (declared in index.css), so they stay on the compositor
 * and cost nothing in JavaScript. `delay` staggers list reveals exactly the way
 * the app does.
 */

export const Reveal = ({ children, delay = 0, className = '', style, as: Tag = 'div', ...rest }) => (
  <Tag
    className={`reveal ${className}`}
    style={{ animationDelay: `${delay}ms`, ...style }}
    {...rest}
  >
    {children}
  </Tag>
);

export const Pop = ({ children, delay = 0, className = '', style, as: Tag = 'div', ...rest }) => (
  <Tag
    className={`pop ${className}`}
    style={{ animationDelay: `${delay}ms`, ...style }}
    {...rest}
  >
    {children}
  </Tag>
);

export const Pulse = ({ children, className = '', style }) => (
  <span className={`pulse ${className}`} style={{ display: 'inline-block', ...style }}>
    {children}
  </span>
);

/** Caps the stagger so a long list never waits seconds for its last row. */
export const stagger = (index, step = 45, max = 300) => Math.min(index * step, max);

const Motion = { Reveal, Pop, Pulse, stagger };
export default Motion;
